import {
  AiMasteringHandler,
  DoAudioStorageData,
  FileSongData,
  FileSongStorageData,
} from "@/services/storage/base/storage-abstractions";
import { AnonServiceUsageStorage } from "@/services/storage/base/anon-service-usage-storage";
import { getActiveLoggingService } from "@/services/logger/logging-service";

export class AiMasteringStorageMixin
  extends AnonServiceUsageStorage
  implements AiMasteringHandler
{
  private readonly masteringResultSongKey = "masteringResultSongChunkData";

  async setResultAudioData(
    audioData: DoAudioStorageData | null,
  ): Promise<void> {
    if (audioData === null) {
      await this.deleteDataDB(this.masteringResultSongKey);
      return;
    }

    const jsonData = JSON.stringify({
      songFile: audioData.songFileUrl,
      title: audioData.title,
    });

    await this.saveDataDbInChunks(this.masteringResultSongKey, jsonData);
  }

  async getResultAudioData(): Promise<FileSongData | null> {
    const jsonLocalFileData = await this.getDataDbByChunks(
      this.masteringResultSongKey,
    );
    if (!jsonLocalFileData) {
      return null;
    }

    const localFileData = JSON.parse(jsonLocalFileData) as FileSongStorageData;

    try {
      const response = await fetch(localFileData.songFile);

      if (!response.ok) {
        await this.deleteDataDB(this.masteringResultSongKey);
        return null;
      }

      return {
        songFile: new File([await response.blob()], localFileData.title),
      };
    } catch (err) {
      getActiveLoggingService().logError(err as Error);

      await this.deleteDataDB(this.masteringResultSongKey);
      return null;
    }
  }
}
